"use client";

import { OverlayProvider } from "@/components/common/TransitionOverlay";
import InterlinkingInjector from "@/components/common/InterlinkingInjector";
import GTMTracker from "@/components/GTMTracker";
import ContactUsForm from "@/components/layout/ContactUsForm";
import Footer from "@/components/layout/Footer";
import Navbar from "@/components/layout/Navbar";
import MobileCTA from "@/components/ui/MobileCTA";
import { usePathname } from "next/navigation";
import { Suspense } from "react";
import "./globals.css";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isContactUsPage = pathname === "/contact-us";
  const isAdminPage = pathname.includes("/admin");
  const isBlogPage = pathname.includes("/blogs");
  const isThankYouPage = pathname === "/thankyou";
  const isContentIntelligence = pathname === "/performance-marketing/usa";
  const isPortfolioPage = pathname === "/portfolios" || pathname.startsWith("/portfolios/");
  const hideGlobalChrome = isAdminPage || isPortfolioPage;
  const isPlaygroundPage = pathname === "/playground";
  return (
    <>
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KGWNSHRT"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
      <GTMTracker />
      <Suspense fallback={null}>
        <InterlinkingInjector />
      </Suspense>
      <OverlayProvider>
        {!hideGlobalChrome && <Navbar />}
        <main>{children}</main>

        {!isContactUsPage &&
          !hideGlobalChrome &&
          !isBlogPage &&
          !isThankYouPage &&
          !isContentIntelligence &&
          !isPlaygroundPage  && (
            <div id="global-contact-form" className="py-8 sm:py-12 lg:py-16 xl:py-20 2xl:py-24">
              <ContactUsForm />
            </div>


          )}
        {!hideGlobalChrome && <Footer />}
        {!isContactUsPage &&
          !hideGlobalChrome &&
          !isBlogPage &&
          !isThankYouPage && <MobileCTA />}
      </OverlayProvider>
    </>
  );
}

